import { IsBoolean } from "class-validator";

export class TemplateMainMenuFieldDto {
  @IsBoolean()
  visible!: boolean;
}
